import React from 'react';

const Button = ({ onClick = null, children = null }) => (
    <button 
      onClick={onClick}
      className="text-white p-2 bg-green-700 "
      >
      {children}
    </button>
  );
  
export default Button;